import { render } from "./GanttChart.vue?vue&type=template&id=29e2ed62&scoped=true"
import script from "./GanttChart.vue?vue&type=script&lang=js"
export * from "./GanttChart.vue?vue&type=script&lang=js"

import "./GanttChart.vue?vue&type=style&index=0&id=29e2ed62&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e2ed62"]])

export default __exports__